// Custom Rosa line-icon set — hand-drawn, in keeping with the warm brand.
// Never use a generic/system icon library. Stroke inherits currentColor.
import type { SVGProps } from 'react';

type P = SVGProps<SVGSVGElement>;
const base = (p: P) => ({
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  ...p,
});

export const Icons = {
  shower: (p: P) => (
    <svg {...base(p)}>
      <path d="M6 21V7a3 3 0 0 1 3-3h1" />
      <path d="M10 4a2 2 0 0 1 4 0" />
      <path d="M14 8h6" />
      <path d="M17 8v2" />
      <path d="M8 13v.5M11 14v.5M14 13v.5M9.5 17v.5M12.5 18v.5" />
    </svg>
  ),
  convert: (p: P) => (
    <svg {...base(p)}>
      <path d="M4 15a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4v-1H4z" />
      <path d="M6 14V7a2 2 0 0 1 2-2" />
      <path d="M16 5l2-2 2 2M18 3v6" />
    </svg>
  ),
  grabbar: (p: P) => (
    <svg {...base(p)}>
      <rect x="3" y="9" width="18" height="4" rx="2" />
      <path d="M6 9V6M18 9V6M6 13v3M18 13v3" />
    </svg>
  ),
  stairlift: (p: P) => (
    <svg {...base(p)}>
      <path d="M3 20h4v-4h4v-4h4V8h4" />
      <circle cx="8.5" cy="10" r="2" />
      <path d="M6.5 14h4v-2a1.5 1.5 0 0 0-3 0" />
    </svg>
  ),
  ramp: (p: P) => (
    <svg {...base(p)}>
      <path d="M3 19h18" />
      <path d="M4 19L18 7v12" />
      <circle cx="10" cy="14.5" r="1.5" />
    </svg>
  ),
  help: (p: P) => (
    <svg {...base(p)}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.8.4-1 1-1 1.7" />
      <path d="M12 17h.01" />
    </svg>
  ),
  shield: (p: P) => (
    <svg {...base(p)}>
      <path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),
  badge: (p: P) => (
    <svg {...base(p)}>
      <circle cx="12" cy="9" r="6" />
      <path d="M9.5 9l1.7 1.7L15 7.5" />
      <path d="M8.5 14.5L7 22l5-3 5 3-1.5-7.5" />
    </svg>
  ),
  clipboard: (p: P) => (
    <svg {...base(p)}>
      <rect x="5" y="4" width="14" height="17" rx="2" />
      <path d="M9 4a3 3 0 0 1 6 0" />
      <path d="M8.5 11l1.5 1.5L13 9.5M8.5 16l1.5 1.5L13 14.5" />
    </svg>
  ),
  heart: (p: P) => (
    <svg {...base(p)}>
      <path d="M12 20s-7-4.3-7-9.3A3.7 3.7 0 0 1 12 8a3.7 3.7 0 0 1 7 2.7c0 5-7 9.3-7 9.3z" />
    </svg>
  ),
  chat: (p: P) => (
    <svg {...base(p)}>
      <path d="M4 5h16v11H9l-4 3v-3H4z" />
      <path d="M8 9h8M8 12h5" />
    </svg>
  ),
  match: (p: P) => (
    <svg {...base(p)}>
      <circle cx="8" cy="9" r="3" />
      <circle cx="16" cy="9" r="3" />
      <path d="M3 19a5 5 0 0 1 10 0M11 19a5 5 0 0 1 10 0" />
    </svg>
  ),
  calendar: (p: P) => (
    <svg {...base(p)}>
      <rect x="4" y="5" width="16" height="16" rx="2" />
      <path d="M4 9h16M8 3v4M16 3v4" />
      <path d="M9 14l2 2 4-4" />
    </svg>
  ),
  check: (p: P) => (
    <svg {...base(p)}>
      <path d="M5 12l4.5 4.5L19 7" />
    </svg>
  ),
  arrowRight: (p: P) => (
    <svg {...base(p)}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  ),
  arrowLeft: (p: P) => (
    <svg {...base(p)}>
      <path d="M19 12H5M11 6l-6 6 6 6" />
    </svg>
  ),
  pin: (p: P) => (
    <svg {...base(p)}>
      <path d="M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11z" />
      <circle cx="12" cy="10" r="2.5" />
    </svg>
  ),
  search: (p: P) => (
    <svg {...base(p)}>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </svg>
  ),
  close: (p: P) => (
    <svg {...base(p)}>
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  ),
  chevronDown: (p: P) => (
    <svg {...base(p)}>
      <path d="M6 9l6 6 6-6" />
    </svg>
  ),
  chevronRight: (p: P) => (
    <svg {...base(p)}>
      <path d="M9 6l6 6-6 6" />
    </svg>
  ),
  phone: (p: P) => (
    <svg {...base(p)}>
      <path d="M6 3h3l1.5 5-2 1.5a11 11 0 0 0 5 5l1.5-2 5 1.5v3a2 2 0 0 1-2.2 2A16 16 0 0 1 4 5.2 2 2 0 0 1 6 3z" />
    </svg>
  ),
  mail: (p: P) => (
    <svg {...base(p)}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M4 7l8 6 8-6" />
    </svg>
  ),
  star: (p: P) => (
    <svg {...base(p)} fill="currentColor" stroke="none">
      <path d="M12 3l2.5 5.5L20 9l-4 4 1 6-5-3-5 3 1-6-4-4 5.5-.5z" />
    </svg>
  ),
  sparkle: (p: P) => (
    <svg {...base(p)}>
      <path d="M12 3v4M12 17v4M3 12h4M17 12h4" />
      <path d="M12 8l1.5 2.5L16 12l-2.5 1.5L12 16l-1.5-2.5L8 12l2.5-1.5z" />
    </svg>
  ),
  user: (p: P) => (
    <svg {...base(p)}>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20a7 7 0 0 1 14 0" />
    </svg>
  ),
  home: (p: P) => (
    <svg {...base(p)}>
      <path d="M4 11l8-6 8 6" />
      <path d="M6 10v10h12V10" />
      <path d="M10 20v-5h4v5" />
    </svg>
  ),
  quote: (p: P) => (
    <svg {...base(p)} fill="currentColor" stroke="none">
      <path d="M8 7c-2.5 0-4 2-4 4.5V17h6v-6H6.5C6.5 9 7 8 8 8zM18 7c-2.5 0-4 2-4 4.5V17h6v-6h-3.5C16.5 9 17 8 18 8z" opacity="0.9" />
    </svg>
  ),
  clock: (p: P) => (
    <svg {...base(p)}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  ),
};

export type IconName = keyof typeof Icons;
